import { axios } from "../middleware";

//home activity
export const getActivityAPI = async (alertType: string, offset = 0) => {
  return axios.get("/user/activity/", {
    params: { limit: 20, ordering: "-time_posted", alert_type: alertType, offset: offset }
  });
};

//wallet balance
export const getWalletBalanceAPI = async () => {
  return axios.get("/cmftstripe/balance/");
};

export const removeActivityByIdAPI = async (id: string) => {
  return axios.delete(`/user/activity/${id}/`);
};

export const viewActivityAPI = async (id: string) => {
  return axios.put(`/user/activity/${id}/`);
};
